import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import FreeChipsBannerDaily from './FreeChipsBannerDaily';
import FreeChipsBannerHourly from './FreeChipsBannerHourly';
import ChipsCard from './ChipsCard';

function GetChips( data ) {

    useEffect(() => {
        if( data.isGetChipsShown ){
            ReactGA.event({
                category: 'Popup',
                action: 'GetChips popup',
                label: 'User opened GetChips popup'
            });
        }
    }, [ data.isGetChipsShown ])

    if( data.isGetChipsShown ){
        return(
            <div className='getChips'>
                <div className='getChips_header'>
                    <div className='getChips_title'><h3>Chips store</h3></div>
                    <div className='closeDialog' onClick={ data.toggleGetChips }>
                        <svg width="16" height="16" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M17.4856 0L20.775 3.32429L13.8134 10.3616L21 17.6249L17.7106 20.9492L10.5244 13.6863L3.28919 21L0 17.6757L7.23521 10.362L0.294176 3.34693L3.58358 0.0226404L10.5241 7.03731L17.4856 0Z" fill="black"/>
                        </svg>
                    </div>
                </div>
                <div className="buyChipsCardGrid">
                    <div class="grid-item">
                        <FreeChipsBannerHourly
                            user={ data.user }
                            socket={ data.socket }
                            toggleGetChips={ data.toggleGetChips }
                            toggleAuth={ data.toggleAuth }
                            amount='100'
                        />
                    </div>
                    <div class="grid-item">
                        <FreeChipsBannerDaily
                            user={ data.user }
                            socket={ data.socket }
                            toggleGetChips={ data.toggleGetChips }
                            toggleAuth={ data.toggleAuth }
                            amount='500'
                        />
                    </div>
                    <div class="grid-item">
                        <ChipsCard image='2' cost='2' amount='3600'/>
                    </div>
                    <div class="grid-item">
                        <ChipsCard image='3' cost='5' amount='35000'/>
                    </div>
                    <div class="grid-item">
                        <ChipsCard image='4' cost='10' amount='100000'/>
                    </div>
                    <div class="grid-item">
                        <ChipsCard image='5' cost='22' amount='500000'/>
                    </div>
                    {/* <div class="grid-item">
                        <ChipsCard image='5' cost='40' amount='900000'/>
                    </div> */}
                </div>
            </div>
        )
    }
}

export default GetChips;